import firebase from 'firebase'

export const remove = (child, callback) => {
  firebase.database().ref(child).remove().then(() => {
    callback()
  })
}
export const update = (child, data, callback) => {
  firebase.database().ref(child).set(data).then(() => {
    callback()
  })
}
export const insert = (child, data, callback) => {
  firebase.database().ref(child).push(data).then(() => {
    callback()
  })
}
export const get = (data) => {
  let ref = firebase.database().ref(data.child)
  if (data.order) {
    ref = ref.orderByChild(data.order)
  }
  if (data.equalTo) {
    ref = ref.equalTo(data.equalTo)
  }
  ref.on('value', (e) => data.callback(e))
}
export const findCurrentData = (contents, data) => {
  return contents.filter(r => r.firebaseKey === data)[0]
}
export const arraySort = (array, sortBy = 'kacinci') => {
  array.sort(function (a, b) {
    const v1 = parseInt(a[sortBy])
    const v2 = parseInt(b[sortBy])
    return v2 - v1
  })
  return array
}
export const arrayAsort = (array, sortBy = 'kacinci') => {
  array.sort(function (a, b) {
    const v1 = parseInt(a[sortBy])
    const v2 = parseInt(b[sortBy])
    return v1 - v2
  })
  return array
}
export const findSortedData = (sort, data, sortBy = 'kacinci') => {
  return sort === 'sort' ? arraySort(data, sortBy) : arrayAsort(data, sortBy)
}

export const findNewKacinci = (data, order) => {
  if (data.length > 0) {
    const max = data.reduce(function (prev, current) {
      return (parseInt(prev[order]) > parseInt(current[order])) ? prev : current
    })
    return (parseInt(max.kacinci) + 1)
  }
  return 1
}
export const findPage = ($route) => {
  return $route.params.page ? $route.params.page.toString() : 1
}
